export default __webpack_public_path__ + "static/ID700-ios-large-0-6987a0ceaefd0a42af397952b0e5cfef.png";